import { FC } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import styles from './styles.module.scss';

type Props = {
  model: CheckoutConfirmationResponseType['QrCodeCheckInSubsection'];
};

export const QrCodeCheckIn: FC<Props> = ({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.qrCodeCheckIn');

  return (
    <div className={styles.qrcode}>
      <p className={styles.description}>{tHelper('title')}</p>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: model.QrCodeSvg }} />
    </div>
  );
};
